<!-- eslint-disable max-len -->
<template>
  <div class="row px-3">
    <div class="col-12 px-0 icon-and-title">
      <!-- Icon -->
      <div
        :class="{'error-input' : $v.page.selectedIcon.$error}"
        class="wrap-icon"
        @click="showModalIcon"
      >
        <img
          v-if="page.selectedIcon"
          :src="page.selectedIcon.icon_grey"
          class="page-icon"
        >
        <p>Change</p>

        <!-- Popup Error -->
        <div
          v-if="$v.page.selectedIcon.$error"
          class="error-icon"
        >
          Please select icon for this menu
        </div>
      </div>
      <!-- Title -->
      <input
        v-model="page.titlePage"
        :class="{'error-input' : $v.page.titlePage.$error}"
        type="text"
        placeholder="Type Title Page"
      >
    </div>

    <!-- Type -->
    <div :class="isPopover ? 'col-12 p-0' : 'col-6 pl-0 pr-1'">
      <div
        :class="{'error-input' : $v.page.selectedType.$error}"
        class="wrap-config"
      >
        <p class="config-header">Type</p>
        <p class="config-description">
          Type of menu for this page
        </p>

        <div class="d-flex align-items-center mt-2">
          <div
            v-for="option in listTypeOptions"
            :key="option.id"
            :class="{
              'active': page.selectedType === option.id,
              'disabled': page.selectedType && mode === 'edit'
            }"
            class="btn-option"
            @click="page.selectedType = option.id"
          >
            <span>{{ option.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Display -->
    <div :class="isPopover ? 'col-12 p-0' : 'col-6 pr-0 pl-1'">
      <div
        :class="{'error-input' : $v.page.displayMode.$error}"
        class="wrap-config"
      >
        <p class="config-header">Display Mode</p>
        <p class="config-description">
          The visibility of screen on the device.
        </p>

        <div class="d-flex align-items-center mt-2">
          <div
            v-for="option in listDisplayOptions"
            :key="option.id"
            :class="{ 'active': displayModeSelected.includes(option.id) }"
            class="btn-option"
            @click="handleDisplayMode(option.id)"
          >
            <div
              v-if="!displayModeSelected.includes(option.id)"
              class="circle-checkbox"
            />
            <img
              v-if="displayModeSelected.includes(option.id)"
              class="checked"
              src="@/assets/new-form-ui/icon-active/check-circle-active.svg"
            >
            <img
              :src="require(`@/assets/form-ui/${option.id}${displayModeSelected.includes(option.id) ? '-active' : ''}.svg`)"
              class="icon-btn"
            >
            <span>{{ option.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Icon -->
    <j-modal-page-icon
      v-if="useModalIcon"
      :id="idModalIcon"
      :icon-options="iconOptions"
      @select-icon="setPageIcon"
      @close-modal="closeModalIcon"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jSwitch from '@/components/inputs/jSwitch';
import jModalPageIcon from '@/views/setting/jModalPageIcon';

export default {
  components: {
    jSwitch,
    jModalPageIcon,
  },

  props: {
    mode: {
      type: String,
      default: 'create',
    },
    isPopover: {
      type: Boolean,
      default: false,
    },
    dataPage: {
      type: Object,
      default: () => {},
    },
    iconOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isFirstLoad: true,
      page: {
        selectedIcon: null,
        titlePage: null,
        selectedType: null,
        displayMode: 0,
        idPage: null,
        orderPage: null,
        parentIdPage: null,
      },
      listTypeOptions: [
        {
          id: 'visible',
          text: 'Single Page',
        },
        {
          id: 'menu',
          text: 'Dropdown Menu',
        },
      ],
      listDisplayOptions: [
        {
          id: 'web',
          text: 'Website',
        },
        {
          id: 'mobile',
          text: 'Mobile',
        },
      ],
      displayModeSelected: [],

      // Modal icon
      useModalIcon: false,
      idModalIcon: 'modalIcon',
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['pages_list']),
  },

  watch: {
    displayModeSelected(val) {
      if (!this.isFirstLoad) {
        if (val.length === 0) this.page.displayMode = 0;
        else if (val.length === 1 && val.includes('web')) this.page.displayMode = 1;
        else if (val.length === 1 && val.includes('mobile')) this.page.displayMode = 2;
        else if (val.length > 1) this.page.displayMode = 3;
      }
    },

    pages_list(val) {
      if (val.length === 0) {
        this.page.selectedType = 'visible';
        this.listTypeOptions = this.listTypeOptions.filter(f => f.id === 'visible');
      } else if (val.length > 0) {
        if (this.mode === 'create') {
          this.page.selectedType = '';
          this.listTypeOptions = [
            {
              id: 'visible',
              text: 'Single Page',
            },
            {
              id: 'menu',
              text: 'Dropdown Menu',
            },
          ];
        }
      }
    },

    dataPage(val) {
      if (!this.isFirstLoad && val) {
        this.page.selectedIcon = val.icon;
        this.page.titlePage = val.title;
        this.page.selectedType = val.type;
        this.page.displayMode = val.show_option;
        this.page.idPage = val.id;
        this.page.orderPage = val.order;
        this.page.parentIdPage = val.parent_id;
        if (val.show_option === 0) this.displayModeSelected = [];
        else if (val.show_option === 1) this.displayModeSelected = ['web'];
        else if (val.show_option === 2) this.displayModeSelected = ['mobile'];
        else if (val.show_option === 3) this.displayModeSelected = ['web', 'mobile'];
        this.listTypeOptions = this.listTypeOptions.filter(f => f.id === this.page.selectedType);
        this.isFirstLoad = false;
      }
    },
  },

  mounted() {
    if (this.dataPage) {
      this.page.selectedIcon = this.dataPage.icon;
      this.page.titlePage = this.dataPage.title;
      this.page.selectedType = this.dataPage.type;
      this.page.displayMode = this.dataPage.show_option;
      this.page.idPage = this.dataPage.id;
      this.page.orderPage = this.dataPage.order;
      this.page.parentIdPage = this.dataPage.parent_id;
      if (this.dataPage.show_option === 0) this.displayModeSelected = [];
      else if (this.dataPage.show_option === 1) this.displayModeSelected = ['web'];
      else if (this.dataPage.show_option === 2) this.displayModeSelected = ['mobile'];
      else if (this.dataPage.show_option === 3) this.displayModeSelected = ['web', 'mobile'];
      this.listTypeOptions = this.listTypeOptions.filter(f => f.id === this.page.selectedType);
      this.isFirstLoad = false;
    } else {
      if (this.mode === 'create' && this.pages_list.length === 0) {
        this.page.selectedType = 'visible';
        this.listTypeOptions = this.listTypeOptions.filter(f => f.id === 'visible');
      }
      if (this.mode === 'createSub') {
        this.page.selectedType = 'visible';
        this.listTypeOptions = this.listTypeOptions.filter(f => f.id === 'visible');
      }
      if (this.mode === 'create' || this.mode === 'createSub') {
        this.page.displayMode = 3;
        this.displayModeSelected = ['web', 'mobile'];
      }

      setTimeout(() => {
        this.isFirstLoad = false;
      }, 200);
    }
  },

  methods: {
    handleDisplayMode(type) {
      if (this.displayModeSelected.includes(type)) {
        this.displayModeSelected = this.displayModeSelected.filter(f => f !== type);
      } else {
        this.displayModeSelected.push(type);
      }
    },

    showModalIcon() {
      this.useModalIcon = true;
      setTimeout(() => {
        const element = document.getElementById(this.idModalIcon);
        if (element) element.classList.add('show');
      }, 300);
    },

    setPageIcon(data) {
      this.page.selectedIcon = data;
      this.closeModalIcon();
    },

    closeModalIcon() {
      const element = document.getElementById(this.idModalIcon);
      if (element) element.classList.remove('show');

      setTimeout(() => {
        this.useModalIcon = false;
      }, 300);
    },

    resetForm() {
      this.page = {
        selectedIcon: null,
        titlePage: null,
        selectedType: null,
        displayMode: 0,
        idPage: null,
        orderPage: null,
        parentIdPage: null,
      };
      if (this.mode === 'create' && this.pages_list.length === 0) {
        this.page.selectedType = 'visible';
        this.listTypeOptions = this.listTypeOptions.filter(f => f.id === 'visible');
      }
      if (this.mode === 'createSub') {
        this.page.selectedType = 'visible';
        this.listTypeOptions = this.listTypeOptions.filter(f => f.id === 'visible');
      }
      if (this.mode === 'create' || this.mode === 'createSub') {
        this.page.displayMode = 3;
        this.displayModeSelected = ['web', 'mobile'];
      }
      this.$v.page.$reset();
    },

    getData() {
      return new Promise((resolve) => {
        this.$v.page.$touch();
        if (!this.$v.page.$error) {
          resolve(this.page);
          if (this.mode === 'create' || this.mode === 'createSub') {
            this.resetForm();
          }
        }
      });
    },
  },

  validations() {
    return {
      page: {
        selectedIcon: { required },
        titlePage: { required },
        selectedType: { required },
        displayMode: { required },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@mixin text($family, $size, $color) {
  font-family: $family;
  font-size: $size;
  color: $color;
}

.icon-and-title {
  display: flex;
  align-items: flex-end;

  .wrap-icon {
    position: relative;
    min-width: 55px;
    max-width: 55px;
    min-height: 55px;
    max-height: 55px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 6px;
    background-color: #E7E7E7;
    border: 1px solid transparent;
    margin-right: 10px;
    cursor: pointer;

    &.error-input {
      border-color: #a94442;
    }
    .page-icon {
      width: 20px;
      height: 20px;
      margin-top: 10px;
    }
    p {
      position: absolute;
      bottom: 5px;
      @include text('Poppins-Medium', 9px, #1A85E4);
      margin-bottom: 0;
    }
    .error-icon {
      position: absolute;
      bottom: 55px;
      width: 104px;
      height: auto;
      padding: 3px 9px;
      border-radius: 6px;
      background-color: #FFFFFF;
      box-shadow: 0px 1px 21px rgba(157, 157, 157, 0.25);
      @include text('Poppins-Medium', 9px, #606060);
      text-align: center;

      &::before {
        content: '';
        position: absolute;
        display: block;
        width: 0px;
        left: 50%;
        bottom: 5px;
        border: 8px solid transparent;
        border-bottom: 0;
        border-top: 8px solid #FFFFFF;
        transform: translate(-50%, calc(100% + 5px));
      }
    }
  }
  input {
    width: 100%;
    height: 35px;
    padding-left: 10px;
    @include text('Poppins-Medium', 14px, #606060);
    border: none;
    border-bottom: 1px solid #CBCBCB;
    transition: all ease 0.3s;

    &::placeholder {
      @include text('Poppins-Regular', 14px, #CBCBCB);
    }
    &:focus {
      outline: none;
      border-color: #606060;
    }
    &.error-input {
      border-color: #a94442;

      &::placeholder {
        color: #a94442;
      }
    }
  }
}

.wrap-config {
  margin-top: 12px;
  border-radius: 10px;
  border: 1px solid #E7E7E7;
  padding: 8px;

  &.error-input {
    border-color: #a94442;
  }
  .config-header {
    @include text('Poppins-Semibold', 12px, #606060);
    margin-bottom: 2px;
  }
  .config-description {
    @include text('Poppins-Regular', 11px, #606060);
    margin-bottom: 0;
    line-height: 12px;
  }
  .btn-option {
    height: 34px;
    display: flex;
    align-items: center;
    padding: 0px 8px;
    margin-right: 4px;
    border-radius: 10px;
    border: 1px solid #E7E7E7;
    cursor: pointer;
    transition: all ease 0.3s;

    span {
      @include text('Poppins-Semibold', 11px, #606060);
    }
    .circle-checkbox {
      width: 12px;
      height: 12px;
      border-radius: 9999px;
      border: 1px solid #606060;
      margin-right: 5px;
    }
    .checked {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
    .icon-btn {
      width: 14px;
      height: auto;
      margin-right: 5px;
    }
    &.active {
      background-color: #F5FAFF;
      border-color: #1A85E4;

      span {
        color: #1A85E4;
      }
    }
    &.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/jFormPage.vue